<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
    export default {
        page: {
            title: "TV Show Details",
            meta: [
                {
                name: "description",
                content: appConfig.description,
                },
            ],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: "TV Show Details",
                items: [
                {
                    text: "TV Show",
                    href: "/tvshows",
                },                
                
                {
                    text: "Details",
                    active: true,
                },                     
                ],

                tv_show: {},
                tv_names: [],

                errors: {},
                token: '',

            };
        },
        mounted() {
        
        },

        created() {
            this.fetchTvShowDetail();
        },

        methods: {

            getToken() {
                if (localStorage.getItem('medicino_admin')) {
                var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                if(medicino_admin.token) {
                    this.token = medicino_admin.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
                
                } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
                }
            }, 

            fetchTvShowDetail() {
                let url = "api/admin/tvShowDetail?id=" + this.$route.params.id;         
                this.getToken();
                this.loading = true;
                this.$axios
                .get(url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                var responseData = res.data.data;
                console.log(responseData);
                this.tv_show = responseData.tv_shows;  
                this.tv_names = this.tv_show.tv_names;
                        
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            if(typeof error.response.data.message === 'object') {
                            console.log(error.response.status);
                            } else {
                            this.$swal("", error.response.data.message, "error");
                            }                        
                            
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            },

        }
    }
</script>
    
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                   
                        <!----- top button area starts---->
                        <div class="row mb-2">
                            <div class="col-12">
                                <router-link :to="{ name: 'tvshows' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                            </div>
                        </div>
                        <!----- top button area ends---->                  

                        <!---- Details starts -------->
                        <div class="row">

                            <div class="col-lg-12 col-md-12">
                                <b-card header-class="bg-transparent border-light" class="border border-light">
                                    <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">TV Show Details</h4>

                                    <div class="table-responsive ">
                                        <table class="table table-nowrap mb-0">
                                            <tbody>
                                                <tr width="50%">
                                                    <th scope="row">Title</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.title}}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">For</th>
                                                    <th>:</th>
                                                    <td>
                                                        <span v-if="tv_show.type==1">All Clinics</span>
                                                        <span v-if="tv_show.type==2">Multiple Clinics</span>
                                                        <span v-if="tv_show.type==3">All Doctors</span>
                                                        <span v-if="tv_show.type==4">Multiple Doctors</span>
                                                        <span v-if="tv_show.type==5">Specific Clinic</span>
                                                        <span v-if="tv_show.type==6">Specific Doctor</span>
                                                        <span v-if="tv_show.type==7">All Pharmacies</span>
                                                        <span v-if="tv_show.type==8">Multiple Pharmacies</span>
                                                        <span v-if="tv_show.type==9">Specific Pharmacy</span>
                                                        <span v-if="tv_show.type==10">All Labs</span>
                                                        <span v-if="tv_show.type==11">Multiple Labs</span>
                                                        <span v-if="tv_show.type==12">Specific Lab</span>
                                                    </td>
                                                </tr> 

                                                <tr>
                                                    <th scope="row">Agency</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.agency_name}}</td>
                                                </tr>  

                                                <tr v-if="tv_show.clinic_id">
                                                    <th scope="row">Clinic</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.clinic_name}}</td>
                                                </tr>  

                                                <tr v-if="tv_show.doctor_id">
                                                    <th scope="row">Doctor</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.doctor_name}}</td>
                                                </tr> 

                                                <tr v-if="tv_show.pharmacy_id">
                                                    <th scope="row">Pharmacy</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.pharmacy_name}}</td>
                                                </tr>  

                                                <tr v-if="tv_show.lab_id">
                                                    <th scope="row">Lab</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.lab_name}}</td>
                                                </tr>  

                                                <tr>
                                                    <th scope="row">Duration</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.duration}} sec</td>
                                                </tr>  

                                                <tr>
                                                    <th scope="row">Slot</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.slot}}</td>
                                                </tr>  

                                                <tr>
                                                    <th scope="row">Expired on</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.validity | formatDate}}</td>
                                                </tr>    

                                                <tr>
                                                    <th scope="row">Created on</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.created_at | formatDate}}</td>
                                                </tr>    

                                                <tr>
                                                    <th scope="row">Video</th>
                                                    <th>:</th>
                                                    <td>
                                                        <a :href="$image_url + tv_show.video" target="_blank" class="font-size-22"><i class='bx bx-video'></i></a>
                                                    </td>
                                                </tr>  
                                            </tbody>
                                        </table>
                                    </div>

                                    <div v-if="Boolean(tv_names.length)">
                                        <div class="table-responsive">
                                            <table class="table table-bordered mb-0">
                                                <thead class="table-light">
                                                    <tr align="center">
                                                        <th>TV Id</th>
                                                        <th>Name</th>
                                                        <th>Username</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="tv in tv_names" :key="tv.id" align="center">
                                                        <td>{{tv.id}}</td>
                                                        <td>{{tv.name}}</td>
                                                        <td>{{tv.username}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                
                                </b-card>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
